export const isNativeTabbable = (element: EventTarget) =>
  element instanceof HTMLButtonElement ||
  element instanceof HTMLInputElement ||
  element instanceof HTMLSelectElement ||
  element instanceof HTMLTextAreaElement ||
  element instanceof HTMLAnchorElement ||
  element instanceof HTMLAudioElement ||
  element instanceof HTMLVideoElement
